import React, { useState } from "react"
import { observer } from "mobx-react-lite"
import styled, { useTheme } from "~/ui/styled"
import {
  Flex,
  ColumnFlex,
  CenterFlex,
  BetweenFlex,
  Text,
  IconFont,
  StartFlex,
} from "~components/El"
import Select from "../components/Select"
import { NotDisturbModeScreenProps } from "./types"
import { useSafeAreaInsets } from "~/ui/safe-area"

const Container = styled.ScrollView`
  flex-direction: column;
  flex: 1;
  padding: 0 12px;
`

const columns = [
  { label: "小", alias: "选择在线状态的显示方式", desc: "这是小号字体的预览效果，适合密集阅读", value: "1m" },
  { label: "中(推荐)", alias: "系统默认字体大小", desc: "这是小号字体的预览效果，适合密集阅读", value: "system" },
  { label: "大", alias: "更清晰易读的字体大小", desc: "这是小号字体的预览效果，适合密集阅读", value: "3m" },
  { label: "特大", alias: "最大字体，适合视力不佳用户", desc: "这是小号字体的预览效果，适合密集阅读", value: "4m" },
]
const TipCur: React.FC<any> = ({ icon, title = "", content = "", color = "", bg = "" }) => {
  return (
    <BetweenFlex
      bg={bg}
      style={{
        borderRadius: 8,
        alignItems: "flex-start",
        marginTop: 10,
        padding: 10,
      }}
    >
  {   icon&& <IconFont flex={1} name={icon} size={16} color={color} />}
      <ColumnFlex flex={11}>
        <Text color={color} fontWeight={600} fontSize="14px" mb={4}>
          {title}
        </Text>
        <Text color={color} fontSize="12px" lineHeight={18}>
          {content}
        </Text>
      </ColumnFlex>
    </BetweenFlex>
  )
}
const LabelComponent = ({ item, active }) => {
  const theme = useTheme()
  return (
    <StartFlex flex={9} style={{ paddingRight: 8 }}>
      {/* <CenterFlex
        style={{
          width: 36,
          height: 36,
          borderRadius: 18,
          backgroundColor: theme.colors.primaryText + "22",
          marginRight: 12,
        }}
      >
        <IconFont
          name={item.value === "system" ? "gensuixitong" : "yuyan"}
          size={16}
          color={theme.colors.primaryText}
        />
      </CenterFlex> */}
      <ColumnFlex>
        <Text>{item.label}</Text>
        <Text fontSize="12" color={theme.colors.infoText} mt="6">
          {item.alias || "暂无描述"}
        </Text>
        <Text fontSize="12" color={theme.colors.infoText} mt="6">
          {item.desc || "暂无描述"}
        </Text>
      </ColumnFlex>
    </StartFlex>
  )
}
const FontsizeSettings: React.FC<NotDisturbModeScreenProps> = ({ route }) => {
  const theme = useTheme()
  const [preset, setPreset] = useState("")
  const insets = useSafeAreaInsets()
  return (
    <Container style={{ marginBottom: insets.bottom }}>
      <Flex
        flexDirection="column"
        width="100%"
        mt="10px"
        padding="10px 12px"
        borderRadius="8px"
        bg={theme.colors.blockBackground}
      >
        {/* <BetweenFlex> */}
          <Text flex={1} color={theme.colors.text} fontSize={theme.fontSizes.md} fontWeight="600">
            <IconFont name="ztdx" size={16} color={theme.colors.primaryText} />
            &nbsp;&nbsp;选择文字大小
          </Text>
          {/* <Text>跟随系统</Text> */}
        {/* </BetweenFlex> */}
        <Flex flexDirection="column" width="100%" mt="10px">
          <StartFlex>
            <Text
              color={theme.colors.secondaryText}
              fontSize={theme.fontSizes.md}
              lineHeight="22px"
            >
              调整应用内文字的显示大小，选择最适合您的阅读体验
            </Text>
          </StartFlex>
        </Flex>
      </Flex>
      <ColumnFlex
        width="100%"
        mt="10px"
        padding="0 12px"
        borderRadius="8px"
        bg={theme.colors.blockBackground}
      >
        <Select
          title="可选字体大小"
          description="选择你偏好的字体大小"
          LabelComponent={LabelComponent}
          options={columns}
          value={preset}
          onChange={(val) => {
            setPreset(val)
          }}
        />
      </ColumnFlex>
      {/* <TipCur
        title="语言切换说明"
        content="更改语言后需要重启应用才能完全生效。部分内容可能需要重新加载。"
        icon="ztdx"
        color={"#9a3412"}
        bg="#fffbeb"
      /> */}
      <TipCur
        title="温馨提示"
        content='为了安全起见，您需填写谷歌验证码进行身份验证，禁用后不再使用谷歌验证器进行双重验证。'
        
        color={theme.colors.primaryText}
        bg="#3187e219"
      />
    </Container>
  )
}

export default observer(FontsizeSettings)
